import { render, staticRenderFns } from "./DragandDrop.vue?vue&type=template&id=025af888&scoped=true&"
import script from "./DragandDrop.vue?vue&type=script&lang=js&"
export * from "./DragandDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragandDrop.vue?vue&type=style&index=0&id=025af888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025af888",
  null
  
)

export default component.exports